import React from 'react';
import { PersonalityType, PersonalityOptions } from '../PersonalitySelector/PersonalitySelector';

function PersonalityTabs({ selectedPersonality, onPersonalityChange, disabled = false }) {
    const handleTabClick = (personality) => {
        if (!disabled && personality !== selectedPersonality) {
            onPersonalityChange(personality);
        }
    };

    return (
        <div className="personality-tabs">
            {Object.entries(PersonalityOptions).map(([key, option]) => (
                <button
                    key={key}
                    className={`personality-tab ${selectedPersonality === key ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
                    onClick={() => handleTabClick(key)}
                    disabled={disabled}
                >
                    <span className="tab-icon">{option.icon}</span>
                    <span className="tab-name">{option.name}</span>
                </button>
            ))}
        </div>
    );
}

export default PersonalityTabs; 